import { Backdrop, Box, CircularProgress, makeStyles, Typography } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
    backdrop: {
      zIndex: theme.zIndex.modal + 1,
      color: '#fff',
      width: '100%'
    },
  }));

function CircularProgressWithLabel(props) {
    return (
      <Box position="relative" display="inline-flex">
        <CircularProgress variant="determinate" {...props} />
        <Box
          top={0}
          left={0}
          bottom={0}
          right={0}
          position="absolute"
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <Typography variant="caption" component="div" color="textSecondary">{`${Math.round(
            props.value,
          )}%`}</Typography>
        </Box>
      </Box>
    );
}
function FullscreenLoading(props){
    const {open, progress} = props;
    const classes = useStyles()

    return (
        <Backdrop className={classes.backdrop} open={open}>
            {progress !== undefined ?
                <CircularProgressWithLabel value={progress}/>
                :
                <CircularProgress color='secondary'/>
            }
        </Backdrop>
    )
}

FullscreenLoading.defaultProps = {
    open: false
}

export default FullscreenLoading